import { useLayoutEffect, useRef } from 'react';

import type { RefObject } from 'react';

export default function useDocumentPreviewDialogFocus(
  open: boolean,
  dialogRef: RefObject<HTMLElement>,
) {
  const previouslyFocusedRef = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    if (!open) {
      return;
    }

    previouslyFocusedRef.current =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;
    dialogRef.current?.focus();

    return () => {
      const previouslyFocused = previouslyFocusedRef.current;
      previouslyFocusedRef.current = null;
      if (previouslyFocused == null || !previouslyFocused.isConnected) {
        return;
      }

      const active = document.activeElement;
      if (
        (dialogRef.current != null && dialogRef.current.contains(active)) ||
        active == null ||
        active === document.body
      ) {
        previouslyFocused.focus();
      }
    };
  }, [dialogRef, open]);
}
